"use client";

import Link from "next/link";
import { PenLine, Sparkles, FileText, Zap } from "lucide-react";

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
}

const features = [
  { icon: Sparkles, text: "AI Agent 智能写作，自动规划与生成" },
  { icon: FileText, text: "多文档管理，支持大纲与实时编辑" },
  { icon: Zap, text: "素材库与记忆，让写作更精准" },
];

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="flex min-h-full">
      <aside className="relative hidden w-[45%] max-w-xl flex-col justify-between overflow-hidden bg-[#171717] p-10 text-white lg:flex">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(255,255,255,0.08)_0%,_transparent_60%)]" />
        <div className="relative">
          <Link href="/" className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-white/10">
              <PenLine className="h-5 w-5" />
            </div>
            <span className="text-lg font-semibold tracking-tight">智写</span>
          </Link>
        </div>

        <div className="relative space-y-8">
          <div>
            <h1 className="font-heading text-4xl font-medium leading-tight tracking-tight">
              AI 驱动的
              <br />
              专业写作助手
            </h1>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
              描述你的写作需求，Agent 将为你调研、构思、撰写并优化文章。
            </p>
          </div>
          <ul className="space-y-4">
            {features.map(({ icon: Icon, text }) => (
              <li key={text} className="flex items-start gap-3 text-sm text-white/80">
                <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-white/10">
                  <Icon className="h-3.5 w-3.5" />
                </div>
                {text}
              </li>
            ))}
          </ul>
        </div>

        <p className="relative text-xs text-white/40">
          © {new Date().getFullYear()} 智写 · AI Writing
        </p>
      </aside>

      <main className="flex flex-1 flex-col items-center justify-center bg-[#FAFAF8] px-6 py-12">
        <div className="mb-8 flex items-center gap-2.5 lg:hidden">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <PenLine className="h-5 w-5" />
          </div>
          <span className="text-lg font-semibold">智写</span>
        </div>

        <div className="w-full max-w-md">
          <div className="mb-8 text-center lg:text-left">
            <h2 className="font-heading text-2xl font-medium tracking-tight text-foreground">
              {title}
            </h2>
            <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
